<div class="flex justify-center h-screen mt-5 mb-5"> <!-- altura total de la pantalla -->
  <div class="border-2 box-content p-0 rounded-lg w-full max-w-[400px] h-full flex flex-col">
    <!-- HEADER fijo -->
    <ng-container *ngIf="header().components.length > 0">
      <lib-list-section-components
        [components]="header().components"
        [backgroundColor]="header().properties.background"
        sectionClass="relative min-h-[100px] flex-none"
      ></lib-list-section-components>
    </ng-container>

    <!-- BODY scrollable -->
    <div class="flex-1 overflow-y-auto">
      <lib-list-section-components
        [components]="body().components"
        [backgroundColor]="body().properties.background"
        sectionClass="relative min-h-[800px]"
      ></lib-list-section-components>
    </div>

    <!-- FOOTER fijo -->
    <ng-container *ngIf="footer().components.length > 0">
      <lib-list-section-components
        [components]="footer().components"
        [backgroundColor]="footer().properties.background"
        sectionClass="relative py-4 flex-none min-h-[100px]"
      ></lib-list-section-components>
    </ng-container>
  </div>
</div>
